import {
    createSlice
} from "@reduxjs/toolkit";

const initialState = {
    drawerOpen: false,
    loading: false,
    agreements: [],
    selectedAgreement: null,
    error: null
};

const transactionSlice = createSlice({
    name: "transaction",

    initialState,

    reducers: {

        openDrawer: state => {
            state.drawerOpen = true;
        },

        closeDrawer: state => {
            state.drawerOpen = false;
        },

        loadAgreementStart: state => {
            state.loading = true;
            state.error = null;
        },

        loadAgreementsSuccess: (state, action) => {
            state.loading = false;
            state.agreements = action.payload;
            state.error = null;
        },

        loadAgreementSuccess: (state, action) => {
            state.loading = false;
            state.selectedAgreement =
                action.payload;
            state.error = null;
        },

        loadAgreementFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        clearTransaction: state => {
            state.drawerOpen = false;
            state.loading = false;
            state.selectedAgreement = null;
            state.error = null;
        }

    }
});

export const {
    openDrawer,
    closeDrawer,
    loadAgreementStart,
    loadAgreementsSuccess,
    loadAgreementSuccess,
    loadAgreementFailure,
    clearTransaction
} = transactionSlice.actions;

export default transactionSlice.reducer;